import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './MobileFullscreenModal.style';

const MobileFullscreenModal = ({ onClose, children }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className="mobile-modal">
      <div className="mobile-modal-header">
        <button type="button" className="mobile-modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="mobile-modal-title">Dimensionar tablero</h2>
      </div>
      <div className="mobile-modal-content">{children}</div>
      <style jsx>{styles}</style>
    </div>
  );
};

MobileFullscreenModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default MobileFullscreenModal;
